module.exports = __webpack_public_path__ + "media/images/regional-image18-f1e7b7fa00d546a0afa922fff350b8d7.jpg";